import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Storage } from '@ionic/storage';
import { ToastController, LoadingController,Platform,AlertController, MenuController } from '@ionic/angular';
import {Network} from '@ionic-native/network/ngx';
import { Login } from '../models/Login';
import {Helper} from '../services/Helper';
import { APIService } from '../services/APIService';



@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {


  loginInfo: Login;
  credentialsForm: FormGroup;
  Regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  isLoggedIn:false;
  token:any; 
  pwdHide:true;
  loader: any;
  logindata:any

  
  constructor(private router:Router,private storage: Storage,public toastController: ToastController,private network: Network,public loadingController: LoadingController,public helper: Helper,private apiservice: APIService,private splashScreen: SplashScreen,private alertCtrl: AlertController, private platform: Platform,private formBuilder: FormBuilder,private menuCtrl:MenuController ) {

 


  this.platform.backButton.subscribeWithPriority(1, () => {
          this.router.navigate(['tabs/tab1']);
  });


  this.credentialsForm = this.formBuilder.group({
    mobile: [
      '', Validators.compose([
        Validators.pattern(this.Regex),
        Validators.required
      ])
    ],

  });

  this.loginInfo = new Login();




  }
  ngOnInit() {
  }



  ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }


  login(value: any) {
    console.log(value);
    if (!value.mobile || !this.credentialsForm.controls.mobile.valid) {
      this.helper.presentToastError('Please Enter Mobile Number!');

    } else if (!(this.network.type !== 'none' && this.network.type !== 'unknown')) {
      this.helper.presentToast('Please on Internet Connection!');
    } else {
      this.loginInfo.phone = value.mobile;

            /*Call API For Login*/
      /*this.helper.showLoader('Processing');*/
      this.presentLoading().then(() => {
            this.apiservice.PatentNewOtp(this.loginInfo).subscribe(
                response => {
                    console.log('responseBody' , response.body);
                    if(response.body.status == 'success'){
                      this.storage.set("otpmobile",  this.loginInfo.phone);
                      this.dismissLoading();
                      this.router.navigate(['/check-otp']);
                    }
                    if(response.body.status == 'fail'){
                      this.helper.presentToastError(response.body.message);
                      this.dismissLoading();
                    }
      
                }, error => {
                    this.dismissLoading();
                    this.helper.presentToastError(error.error.message);
                });
        });
    }
  }



  register(){
    this.router.navigate(['/register']);
  }

  back(){
    this.router.navigate(['/tabs/tab1']);
  }

  forgotPassword(){
    this.router.navigate(['/forgot-pass']);
  }

  async presentLoading() {
    this.loader = await this.loadingController.create({
        translucent: true
    });
    await this.loader.present();
  }

  async dismissLoading() {
    await this.loader.dismiss();
  }


async exitapp() {



  const me = this;
  const alert = await this.alertCtrl.create({
    header: 'Exit App',
    message: 'Are you sure you want to exit app?',
    buttons: [
      {
        text: 'No',
        role: 'no',
        handler: () => {
        }
      },
      {
        text: 'Yes',
        handler: () => {

          (navigator as any).app.exitApp();


        }
      }
    ]
  });
  await alert.present();
}




}
